import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: [ './input.component.scss' ],
})
export class InputComponent {
  @Input() label: string;
  @Input() value: any;
  @Input() type: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() error: string;
  @Input() icon: string;
  @Input() iconSide: string;
  @Input() color: string;
  @Input() required: boolean;
  @Input() email: boolean;
  @Input() debounceTime = 0;
  @Input() minimum: number;
  @Input() maximum: number;
  @Output() updatedValue = new EventEmitter<any>();

  onValueChange(newValue: any) {
    // Emit the value directly whenever it changes (typing, paste, etc.)
    this.updatedValue.emit({ target: { value: newValue } });
  }
}
